module.exports = __webpack_public_path__ + "img/01.15252a5e.jpg";